module.exports = __webpack_public_path__ + "img/2eb8c.cf502e0b.svg";